module.exports = __webpack_public_path__ + "static/media/avenir-next-thin.7872f828.woff";